/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
import type { markerpinEventByRefs$ref } from "./markerpinEventByRefs.graphql";
export type markerpinByRefsQueryVariables = {|
  refs?: ?$ReadOnlyArray<string>
|};
export type markerpinByRefsQueryResponse = {|
  +$fragmentRefs: markerpinEventByRefs$ref
|};
export type markerpinByRefsQuery = {|
  variables: markerpinByRefsQueryVariables,
  response: markerpinByRefsQueryResponse,
|};
*/


/*
query markerpinByRefsQuery(
  $refs: [String!]
) {
  ...markerpinEventByRefs_2P6Ouq
}

fragment markerpinEventByRefs_2P6Ouq on Query {
  results: spaceGetByRefs(refs: $refs) {
    ref
    title
    dataByCategory(category: "production") {
      price {
        amount_excl_tax
      }
    }
    pictures(count: 3) {
      nameId
      extension
      predictName
      id
    }
    urlSpacefr: urlByLang(lang: "fr")
    urlSpaceen: urlByLang(lang: "en")
    urlSpacees: urlByLang(lang: "es")
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refs"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "refs",
    "variableName": "refs"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "markerpinByRefsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "markerpinEventByRefs"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "markerpinByRefsQuery",
    "selections": [
      {
        "alias": "results",
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "spaceGetByRefs",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ref",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "category",
                "value": "production"
              }
            ],
            "concreteType": "DataByCategory",
            "kind": "LinkedField",
            "name": "dataByCategory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Price",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amount_excl_tax",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "dataByCategory(category:\"production\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "count",
                "value": 3
              }
            ],
            "concreteType": "SpacePicture",
            "kind": "LinkedField",
            "name": "pictures",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nameId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "extension",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "predictName",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": "pictures(count:3)"
          },
          {
            "alias": "urlSpacefr",
            "args": [
              {
                "kind": "Literal",
                "name": "lang",
                "value": "fr"
              }
            ],
            "kind": "ScalarField",
            "name": "urlByLang",
            "storageKey": "urlByLang(lang:\"fr\")"
          },
          {
            "alias": "urlSpaceen",
            "args": [
              {
                "kind": "Literal",
                "name": "lang",
                "value": "en"
              }
            ],
            "kind": "ScalarField",
            "name": "urlByLang",
            "storageKey": "urlByLang(lang:\"en\")"
          },
          {
            "alias": "urlSpacees",
            "args": [
              {
                "kind": "Literal",
                "name": "lang",
                "value": "es"
              }
            ],
            "kind": "ScalarField",
            "name": "urlByLang",
            "storageKey": "urlByLang(lang:\"es\")"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "74d52da4144433caa66c42bbe2f709bf",
    "id": null,
    "metadata": {},
    "name": "markerpinByRefsQuery",
    "operationKind": "query",
    "text": "query markerpinByRefsQuery(\n  $refs: [String!]\n) {\n  ...markerpinEventByRefs_2P6Ouq\n}\n\nfragment markerpinEventByRefs_2P6Ouq on Query {\n  results: spaceGetByRefs(refs: $refs) {\n    ref\n    title\n    dataByCategory(category: \"production\") {\n      price {\n        amount_excl_tax\n      }\n    }\n    pictures(count: 3) {\n      nameId\n      extension\n      predictName\n      id\n    }\n    urlSpacefr: urlByLang(lang: \"fr\")\n    urlSpaceen: urlByLang(lang: \"en\")\n    urlSpacees: urlByLang(lang: \"es\")\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1aeceb0f30335ecafcafe7c63491d19a';

module.exports = node;
